import React from 'react';

const SaveIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.7772 2H3.33923C2.59923 2 2.00056 2.60267 2.00589 3.34333L2.07523 12.6767C2.08056 13.4093 2.67589 14 3.40856 14H12.6626C13.3992 14 13.9959 13.4033 13.9959 12.6667V5.21867C13.9959 4.86533 13.8552 4.526 13.6052 4.276L11.7199 2.39067C11.4699 2.14067 11.1312 2 10.7772 2Z"
      strokeWidth="1.1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.6634 2V4.606C10.6634 4.974 10.3647 5.27267 9.99674 5.27267H5.99674C5.62874 5.27267 5.33008 4.974 5.33008 4.606V2"
      strokeWidth="1.1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.66797 14V8.85733C4.66797 8.384 5.05197 8 5.5253 8H10.478C10.9506 8 11.3346 8.384 11.3346 8.85733V14"
      strokeWidth="1.1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SaveIcon;
